import {
  afterNextRender,
  Component,
  computed,
  ElementRef,
  HostListener,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import {NgClass} from '@angular/common';
import {IconField} from 'primeng/iconfield';
import {InputIcon} from 'primeng/inputicon';
import {InputTextModule} from 'primeng/inputtext';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  imports: [IconField, InputIcon, InputTextModule, NgClass, TranslocoPipe],
})
export class GlobalSearchComponent {
  readonly placeholderKey = input('common.search');
  readonly testId = input<string>('');
  readonly fullWidth = input<boolean>(false);

  readonly searchValue = output<string>();

  readonly value = signal('');

  private readonly inputRef = viewChild<ElementRef<HTMLInputElement>>('input');

  protected readonly widthClass = computed<string>(() => (this.fullWidth() ? 'w-full' : 'w-72'));

  constructor() {
    afterNextRender(() => this.searchValue.emit(this.value()));
  }

  @HostListener('document:keydown', ['$event'])
  onShortcut(event: KeyboardEvent): void {
    if (event.altKey && event.key === '/') {
      event.preventDefault();
      this.inputRef()?.nativeElement.focus();
    }
  }

  onInput(value: string): void {
    this.value.set(value);
    this.searchValue.emit(value);
  }

  clear(): void {
    this.value.set('');
    this.searchValue.emit('');
  }
}
